import { useState, useCallback } from 'react';

export function useRecaptcha() {
  const [token, setToken] = useState<string | null>(null);

  const verifyHuman = useCallback(async () => {
    // For now, return true to allow the application to work
    // TODO: Implement proper reCAPTCHA verification when site key is available
    return true;
  }, []);

  return { verifyHuman, token };
}